import { render, staticRenderFns } from "./TrainingSessionPage.vue?vue&type=template&id=526452a4&"
import script from "./TrainingSessionPage.vue?vue&type=script&lang=js&"
export * from "./TrainingSessionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports